const ComplianceInformation = (function ($) {
    'use strict';
    const Self = {
        State: {
            SignUpButtonIsEnabled: false
        },
        Elements: {
            Buttons: {
                BookNowButton: '#compliance-book-now-button',
                SignUpButton: '#compliance-sign-up-button',
                PleaseWaitButton: '#compliance-please-wait-button',
                RefreshButton: '#compliance-refresh-button',
                ComplianceButtons: '.compliance-button',
                GuardedButtons: '.guarded-button'
            },
            Checkboxes: {
                Guards: '.checkbox-guard'
            }
        },
        Func: {
            Init: function () {
                Self.Func.Bindings();
            },
            Bindings: function () {
                $(Self.Elements.Buttons.ComplianceButtons).on('click', Self.Func.PreventFormSubmission);
                $(Self.Elements.Checkboxes.Guards).on('click', Self.Func.HandleComplianceCheck);
            },
            ReloadPage: function () {
                window.location.reload(true);
            },
            PreventFormSubmission: function (event) {
                if (event) event.preventDefault();
            },
            SwitchComplianceButton: function (buttonSelector) {
                $(Self.Elements.Buttons.ComplianceButtons).hide();
                $(buttonSelector).show();
            },
            HandleComplianceCheck: function () {
                Self.Func.HandleGuardCheck(function (buttonEnabled) {
                    Self.State.SignUpButtonIsEnabled = buttonEnabled;
                });
            },
            HandleGuardCheck: function (callback) {
                // Guarded buttons become enabled once all guards are checked
                const uncheckedBoxes = $(Self.Elements.Checkboxes.Guards + ':not(:checked)');
                const allGuardsChecked = uncheckedBoxes.length === 0;

                $(Self.Elements.Buttons.GuardedButtons).each(function () {
                    if (allGuardsChecked) {
                        $(this).removeClass('vds-button--disabled');
                        $(this).prop('disabled', false);
                    } else {
                        $(this).addClass('vds-button--disabled');
                        $(this).prop('disabled', true);
                    }
                });

                if (callback) {
                    callback(allGuardsChecked);
                }
            },
            IsSignUpButtonEnabled: function () {
                return Self.State.SignUpButtonIsEnabled;
            },
            SwitchToSignUpButton: function () {
                Self.Func.SwitchComplianceButton(Self.Elements.Buttons.SignUpButton);
            },
            SwitchToPleaseWaitButton: function () {
                Self.Func.SwitchComplianceButton(Self.Elements.Buttons.PleaseWaitButton);
            },
            SwitchToRefreshButton: function () {
                Self.Func.SwitchComplianceButton(Self.Elements.Buttons.RefreshButton);
            }
        }
    };

    return {
        Init: Self.Func.Init,
        Elements: Object.freeze(Self.Elements),
        Func: Object.freeze({
            IsSignUpButtonEnabled: Self.Func.IsSignUpButtonEnabled,
            SwitchToSignUpButton: Self.Func.SwitchToSignUpButton,
            SwitchToPleaseWaitButton: Self.Func.SwitchToPleaseWaitButton,
            SwitchToRefreshButton: Self.Func.SwitchToRefreshButton
        })
    };
})(jQuery);

$('document').ready(function () {
    ComplianceInformation.Init();
});
